import React, { useEffect, useState } from 'react'

import { useLocalStorage } from './useLocalStorage'
import { useMediaQuery } from './useMediaQuery'

export const useSidebarState = () => {
  // JIRA - IT02 - No se colapsa el Sidebar en resoluciones Desktop
  // Implementación simple de localStorage sin el hook complejo
  const [isCollapsed, setIsCollapsedState] = React.useState<boolean>(() => {
    try {
      const item = localStorage.getItem('sidebar-collapsed')
      return item ? JSON.parse(item) : false
    } catch {
      return false
    }
  })

  const setIsCollapsed = React.useCallback(
    (value: boolean | ((prev: boolean) => boolean)) => {
      const newValue = typeof value === 'function' ? value(isCollapsed) : value

      // Actualizar localStorage
      try {
        localStorage.setItem('sidebar-collapsed', JSON.stringify(newValue))
      } catch (error) {
        console.error('Error saving to localStorage:', error)
      }

      // Actualizar estado
      setIsCollapsedState(newValue)
    },
    [isCollapsed]
  )
  const [openItems, setOpenItems] = useLocalStorage<string[]>('sidebar-open-items', [])
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const isMobile = useMediaQuery('(max-width: 1024px)')

  // Reset collapsed state on mobile
  useEffect(() => {
    if (isMobile && isCollapsed) {
      setIsCollapsed(false)
    }
  }, [isMobile, isCollapsed, setIsCollapsed])

  const toggleCollapse = () => {
    if (!isMobile) {
      setIsCollapsed(!isCollapsed)
    }
  }

  const toggleMobile = () => {
    setIsMobileOpen(!isMobileOpen)
  }

  const toggleItem = (itemId: string) => {
    setOpenItems((prev: string[]) =>
      prev.includes(itemId) ? prev.filter((id: string) => id !== itemId) : [...prev, itemId]
    )
  }

  return {
    isCollapsed: isMobile ? false : isCollapsed,
    isMobileOpen,
    openItems,
    toggleCollapse,
    toggleMobile,
    toggleItem,
    setMobileOpen: setIsMobileOpen
  }
}
